// src/pages/restaurant-tables/AfricanCategories.jsx
import React from 'react';
import CategoryList from '../CategoryList';

const AfricanCategories = () => {
  return <CategoryList locationKey="african" />;
};

export default AfricanCategories;